import elementUtils from 'utils/elementUtils';
import guardUtils from 'utils/guardUtils';
import rangeUtils from 'utils/rangeUtils';
import utils from 'utils/utils';

export default class SelectionIntention {
    constructor(editor, container, offset, moveOutOfGuard = true) {
        this.container = container;
        this.offset = offset;
        this.editor = editor;
        if (moveOutOfGuard) {
            this.setAfterGuard();
        }
    }

    setAfterGuard() {
        const path = new CKEDITOR.dom.elementPath(this.container);
        const textBlock = utils.getBlockParent(path);
        const guard = guardUtils.getGuard(textBlock);
        if (guard && path.contains(guard)) {
            this.container = guard.getParent();
            this.offset = guard.getIndex() + 1;
        }
    }

    getRange() {
        return rangeUtils.createRange(this.editor.editable(), this.container, this.offset);
    }

    getThemeClass() {
        const path = new CKEDITOR.dom.elementPath(this.container);
        const textBlock = utils.getBlockParent(path);
        return elementUtils.getTheme(textBlock);
    }
}
